import React, { useState, useEffect } from "react";
import MobileNav from "./Mobile/MobileNav";
import DesktopNav from "./Desktop/DesktopNav";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {/* Fixed Navbar at the Top */}

      <nav className=" bg-gray-100  sticky top-0 w-full  shadow-md">
        {isMobile ? (
          <MobileNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        ) : (
          <DesktopNav />
        )}
      </nav>

      {/* Add padding to avoid content overlap */}
      <div className=" h-[1px] md:h-[1px]"></div>
    </div>
  );
};

export default Navbar;
